import Breadcrumbs from '@v2/shared/components/Breadcrumbs';
import ButtonLink from '@v2/shared/components/ButtonLink';
import ContactInfo, { Company } from '@v2/shared/components/ContactInfo';
import ContentCard from '@v2/shared/components/ContentCard';
import PageHeading from '@v2/shared/components/PageHeading';

/** MagZoom's customer service address, and the only way this page offers to reach them. */
const SUPPORT_EMAIL = 'service@magzoom.com';

export type Props = {
  /** This site's company record, for the address block. See `ContactInfo`. */
  company: Company;
  /** Which pieces of it this site publishes. See `ContactInfo`. */
  displayContactInfo: string[];
};

/**
 * /contact.
 *
 * MagSpot's contact page, brand for brand: no form, a mailto, the same address block and
 * its own words. See the note there about `public/contact.php` still standing behind this
 * template.
 */
export default function Contact({ company, displayContactInfo }: Props) {
  return (
    <>
      <Breadcrumbs items={[{ label: 'Home', href: '/' }, { label: 'Contact Us' }]} />

      <PageHeading eyebrow="Customer Information">Contact Us</PageHeading>

      <div className="prose mt-6 flex flex-col gap-6">
        <ContentCard>
          <p>
            If you have any questions or comments with an order do not hesitate to reach out! Our
            representatives are happy to help at{' '}
            <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
          </p>

          <p>
            Please include the following information so we can provide a prompt and detailed
            response within 24-48 hours:
          </p>

          <ul>
            <li>Order Confirmation Number</li>
            <li>Magazine Title(s)</li>
            <li>Name &amp; Email Address</li>
            <li>Question or Comment</li>
          </ul>

          {/* Left-aligned, as on MagSpot's; see the note there. */}
          <p>
            <ButtonLink href={`mailto:${SUPPORT_EMAIL}`}>Contact Us Now</ButtonLink>
          </p>

          <ContactInfo company={company} displayContactInfo={displayContactInfo} />
        </ContentCard>
      </div>
    </>
  );
}

Contact.layoutName = 'Layouts.Institutional';
